import { render, staticRenderFns } from "./gltf.vue?vue&type=template&id=309d7f9e&scoped=true&"
import script from "./gltf.vue?vue&type=script&lang=js&"
export * from "./gltf.vue?vue&type=script&lang=js&"
import style0 from "./gltf.vue?vue&type=style&index=0&id=309d7f9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309d7f9e",
  null
  
)

export default component.exports